import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { MobileShell, CustomerBottomNav } from "@/components/Shell";
import { MapPin, ChevronRight } from "lucide-react";

export default function LocationPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loc, setLoc] = useState(null);
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    api.get(`/locations/${id}`).then((r) => setLoc(r.data)).catch(() => navigate("/scan"));
    api.get(`/locations/${id}/staff`).then((r) => setStaff(r.data));
  }, [id, navigate]);

  if (!loc) return <MobileShell><div className="p-10 text-center text-[#A1A1AA]">Lade…</div></MobileShell>;

  return (
    <MobileShell>
      <div className="relative h-56 -mb-6">
        {loc.photo_url && <img src={loc.photo_url} alt={loc.name} className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0C]/40 to-[#0A0A0C]"></div>
        <div className="absolute top-0 left-0 right-0 p-5 flex justify-between items-start">
          <Link to="/scan" className="text-xs text-white/80 tracking-[0.2em] uppercase bg-black/40 backdrop-blur px-3 py-1.5 rounded-full">← Zurück</Link>
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#EBB300] bg-black/40 backdrop-blur px-3 py-1.5 rounded-full">Location-QR</div>
        </div>
      </div>

      <div className="relative px-5 pt-2 pb-8">
        <div className="inline-flex items-center gap-1 text-xs text-[#A1A1AA]">
          <MapPin className="w-3 h-3" /> {loc.address}
        </div>
        <h1 className="text-4xl font-black tracking-tight mt-2" data-testid="location-name">{loc.name}</h1>
        <p className="text-[#A1A1AA] mt-3">Wähle ein Teammitglied aus, das heute für dich da war:</p>
      </div>

      <div className="px-5 space-y-3" data-testid="location-staff-list">
        {staff.length === 0 && (
          <div className="text-center text-sm text-[#A1A1AA] py-10 border border-dashed border-white/10 rounded-2xl">
            Aktuell sind keine Mitarbeiter sichtbar.
          </div>
        )}
        {staff.map((s) => (
          <button key={s.id} onClick={() => navigate(`/s/${s.id}?location=${id}`)} data-testid={`location-staff-${s.id}`}
            className="w-full flex items-center gap-4 bg-[#121216] border border-white/5 rounded-2xl p-4 hover:border-[#EBB300]/30 transition-colors text-left">
            <img src={s.photo_url || "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=200"} alt={s.name} className="w-14 h-14 rounded-full object-cover" />
            <div className="flex-1 min-w-0">
              <div className="font-bold truncate">{s.name}</div>
              <div className="text-xs text-[#A1A1AA] truncate">{s.bio?.split(".")[0] || "Service"}</div>
            </div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-[#EBB300]">Auswählen</div>
            <ChevronRight className="w-4 h-4 text-[#52525B]" />
          </button>
        ))}
      </div>

      <CustomerBottomNav />
    </MobileShell>
  );
}
